import { render } from "./RoleView.vue?vue&type=template&id=036ce9e6&scoped=true&ts=true"
import script from "./RoleView.vue?vue&type=script&lang=ts"
export * from "./RoleView.vue?vue&type=script&lang=ts"

import "./RoleView.vue?vue&type=style&index=0&id=036ce9e6&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036ce9e6"]])

export default __exports__